import {Theme, createStyles} from '@material-ui/core';

export const technologyStackStyles = (theme: Theme) =>
	createStyles({
		root: {
			paddingLeft: theme.spacing(7.5),
			paddingRight: theme.spacing(7.5),
			paddingTop: theme.spacing(20),
			paddingBottom: theme.spacing(20),

			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				paddingLeft: 0,
				paddingRight: 0,
			},
		},
		title: {
			display: 'flex',
			justifyContent: 'center',
			textAlign: 'center',
			color: theme.palette.text.primary,
			fontSize: theme.typography.pxToRem(40),
			lineHeight: theme.typography.pxToRem(50),
			whiteSpace: 'pre-line',

			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				fontSize: theme.typography.pxToRem(18),
				lineHeight: theme.typography.pxToRem(26),
				textAlign: 'left',
				justifyContent: 'flex-start',
			},
		},
		subTitle: {
			color: theme.palette.text.secondary,
			textAlign: 'center',
			paddingTop: theme.spacing(2),

			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				paddingBottom: theme.spacing(4),
				textAlign: 'left',
			},
		},
		techGrid: {
			paddingTop: theme.spacing(5),
			display: 'flex',
			justifyContent: 'center',

			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				paddingTop: 0,
			},
		},
		tech: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			textAlign: 'center',
			alignItems: 'center',
			whiteSpace: 'nowrap',

			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				marginBottom: theme.spacing(3),
			},
		},
	});
